<template>
    <div class="root">
        <div class="section-box">
            <div class="section-header">
                메뉴별 매출
            </div>
            <v-layout align-center class="mt-2">
                <div>
                    <date-picker v-model="filter.startDate"></date-picker>
                </div>
                <div>
                    <date-picker v-model="filter.endDate"></date-picker>
                </div>

                <v-spacer></v-spacer>
                <v-btn @click="search()" :loading="loading" :disabled="loading" depressed color="primary">조회</v-btn>
            </v-layout>
        </div>
        <v-alert v-if="errorMessage" type="error" outlined class="mt-2" role="alert">
            {{ errorMessage }}
        </v-alert>
        <div v-else-if="loading" class="section-box mt-2 text-center" role="status">
            메뉴별 매출을 조회하고 있습니다.
        </div>
        <div class="section-box mt-2" v-if="incomeChart && incomesByMenu.length > 0">
            <div class="chart-container">
                <pie-chart :data="incomeChart" :colors="colors"></pie-chart>
            </div>
        </div>
        <div class="section-box mt-2" v-if="!loading && !errorMessage">
            <div class="header">총 메뉴 개수</div>
            <div class="value">
                {{ totalMenuCount }}개
            </div>
            <div class="header">메뉴당 평균매출</div>
            <div class="value">
                {{ averagePrice | number("0") }}원
            </div>
        </div>
        <div v-if="!loading && !errorMessage && incomesByMenu.length === 0" class="section-box mt-2 text-center">
            조회 기간에 메뉴별 매출 내역이 없습니다.
        </div>
        <div class="list" v-if="total">
            <div class="item" v-for="(item, key) in sortByPrice()" :key="key">
                <v-layout align-center>
                    <div class="rate">
                        {{ (total.price ? (item.totalPrice / total.price) * 100 : 0) | number("0.0") }}%
                    </div>
                    <v-flex>{{ item.title }}</v-flex>
                    <div class="text-right">
                        <div class="price">
                            {{ item.totalPrice | number }}원
                        </div>
                        <div class="count">
                            {{ item.count }}건
                        </div>

                    </div>
                </v-layout>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import _ from "lodash"
export default {
    name: "MenuIncome",
    data() {
        return {
            filter: {
                startDate: moment().format("YYYY-MM-DD"),
                endDate: moment().format("YYYY-MM-DD")
            },
            incomesByMenu: [],
            total: null,
            incomeChart: null,
            colors: [],
            loading: false,
            errorMessage: ""
        }
    },
    mounted() {
        this.search()
    },
    computed: {
        totalMenuCount() {
            return _.sumBy(this.incomesByMenu, (item) => {
                return item.count
            })
        },
        totalPrice() {
            return _.sumBy(this.incomesByMenu, (item) => {
                return item.totalPrice
            })
        },
        averagePrice() {
            return this.totalMenuCount ? this.totalPrice / this.totalMenuCount : 0
        }
    },
    methods: {
        sortByPrice() {
            return _.sortBy(this.incomesByMenu, (item) => {
                return item.totalPrice
            }).reverse()
        },
        async search() {
            if (this.loading) return
            this.loading = true
            this.errorMessage = ""
            this.incomesByMenu = []
            this.total = null
            this.incomeChart = null
            this.colors = []
            try {
                const res = await this.$axios.post("/pos/incomes/menu", this.filter)
                if (!res.data.res) {
                    this.errorMessage = res.data.msg || "메뉴별 매출을 불러오지 못했습니다. 다시 조회해 주세요."
                    return
                }
                this.incomesByMenu = res.data.incomesByMenu.map(item => ({
                    ...item,
                    count: Number(item.count),
                    totalPrice: Number(item.totalPrice)
                }))
                this.total = res.data.total
                this.incomeChart = _.map(this.sortByPrice(), (item, key) => {
                    var alpha = 255 - Math.ceil((key + 1) / this.incomesByMenu.length * (250))
                    var alpha16 = alpha.toString(16)
                    if (alpha16.length == 1) {
                        alpha16 = "0" + alpha16
                    }
                    this.colors.push("#ffa600" + alpha16);
                    return {
                        name: item.title,
                        y: item.totalPrice
                    }
                })
            } catch (error) {
                this.errorMessage = "메뉴별 매출을 불러오지 못했습니다. 다시 조회해 주세요."
            } finally {
                this.loading = false
            }
        }
    }
}
</script>

<style scoped lang="less">
.list {
    .item {
        .rate {
            font-size: 20px;
            font-weight: 700;
            margin-right: 20px;
        }

        .price {
            font-size: 20px;
            font-weight: 700;
        }
    }
}

.header {
    font-size: 20px;
    text-align: center;
}

.value {
    font-size: 25px;
    font-weight: 700;
    text-align: center;

}
</style>
